import MdaeLookup from "./component";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
import { ILookupOptions } from "devextreme-react/lookup";
export interface IMdaeLookupProps extends ILookupOptions {
  id: string;
  mdaeLookupTitle: string;
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
  required?: boolean;
}
export default MdaeLookup;
